import { IoSwapHorizontal } from "react-icons/io5";

export const CardFlipper = ({ onFlip }: { onFlip: () => void }) => (
  <div
    className="bg-secondary absolute bottom-4 right-4 z-10 cursor-pointer select-none rounded-full border border-white p-2 opacity-50 transition duration-300 hover:opacity-80"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onFlip();
    }}
  >
    <IoSwapHorizontal size={16} className="text-white" />
  </div>
);
